module.exports = __webpack_public_path__ + "static/media/1014951.ff164946.jpg";